import React, { Component } from 'react';
import { connect } from 'react-redux';
import withRouter from '../../lib/router/withRouter';
import { message } from 'antd';
import BrandTagRequestListWrap from '../../views/brand/list/tag/request/BrandTagRequestListWrap';
import { brandActions } from '../../store/modules/brand';
import { LIST_PAGINATION_MODEL } from '../../store/modules/app/models';
import {
  BRAND_LIST_FILTER_OPTION_MODEL,
  BRAND_TAG_REQUEST_LIST_SORT_OPTION_MODEL,
} from '../../store/modules/brand/models';
import { NO_DATA_ON_EXCEL_DOWNLOAD_WARNING_TEXT } from '../../constants/service/common/utilConstants';

class BrandTagRequestListContainer extends Component {
  componentDidMount() {
    this.initiate();
  }

  initiate = () => {
    const { location } = this.props;

    /**
     *  페이지에 처음 접근하는 것이 아닐 경우, 이전 검색조건으로 검색한다.
     */
    if (location.state) {
      this.getList({
        filterOption: location.state.filterOption,
        sortOption: location.state.sortOption,
        pagination: location.state.pagination,
      });
    } else {
      /**
       *  페이지에 처음 접근하면 초기화된 검색 조건으로 검색한다.
       */
      this.getList({
        filterOption: BRAND_LIST_FILTER_OPTION_MODEL,
        sortOption: BRAND_TAG_REQUEST_LIST_SORT_OPTION_MODEL,
        pagination: LIST_PAGINATION_MODEL,
      });
    }
  };

  getList = (data) => {
    const { getBrandTagRequestList, brandList, history } = this.props;
    const { filterOption, sortOption, pagination } = brandList;

    /**
     *  서버에 요청
     */
    getBrandTagRequestList({
      filterOption,
      sortOption,
      pagination,
      ...data,
    });

    /**
     *  history 에 검색조건을 저장한다
     */
    history.replace({
      ...history.location,
      state: {
        filterOption,
        sortOption,
        pagination,
        ...data,
      },
    });
  };

  /**
   * 엑셀 다운로드
   */
  getExcelDownload = () => {
    const { getBrandTagRequestDownLoad, pageName, brandList } = this.props;

    if (!brandList || !brandList.list.length) {
      message.error(NO_DATA_ON_EXCEL_DOWNLOAD_WARNING_TEXT);
      return;
    }

    getBrandTagRequestDownLoad({
      filterOption: brandList.filterOption,
      sortOption: brandList.sortOption,
      pageName,
    });
  };

  render() {
    const { brandList, getBrandTagColumnTagList } = this.props;

    return (
      <BrandTagRequestListWrap
        brandList={brandList}
        getBrandTagColumnTagList={getBrandTagColumnTagList}
        getList={this.getList}
        getExcelDownload={this.getExcelDownload}
      />
    );
  }
}

const mapStateToProps = (state) => {
  return {
    brandList: state.brand.brandList,
  };
};

const mapDispatchToProps = {
  getBrandTagRequestList: brandActions.getBrandTagRequestList,
  getBrandTagRequestDownLoad: brandActions.getBrandTagRequestDownLoad,
  getBrandTagColumnTagList: brandActions.getBrandTagColumnTagList,
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(BrandTagRequestListContainer));
